<template>
	<div
		class="m-infoCallout"
		:class="{ '-isActive': isComponentActive }"
		@click="handleToggle"
		@keydown.space.prevent="handleToggle"
		@keydown.enter.prevent="handleToggle"
		tabindex="0"
		role="button"
		:aria-pressed="isComponentActive.toString()"
	>
        <div
			class="m-infoCallout__label"
		>
            <span>
                {{ label }}
            </span>
            <div class="a-infoCallout__icon" aria-hidden="true">
                <svg width="2" height="7" viewBox="0 0 2 7" xmlns="http://www.w3.org/2000/svg" focusable="false">
                    <path
                        d="M0.0759821 7V1.59562C0.213474 1.65352 0.354583 1.69693 0.499311 1.72588C0.644039 1.74759 0.799621 1.75844 0.966058 1.75844C1.27722 1.75844 1.5703 1.70417 1.84528 1.59562V7H0.0759821ZM0 0.651275C0 0.419711 0.0759821 0.253274 0.227946 0.151965C0.387147 0.050655 0.629566 0 0.955204 0C1.28084 0 1.51964 0.050655 1.67161 0.151965C1.83081 0.253274 1.91041 0.419711 1.91041 0.651275C1.91041 1.0927 1.59201 1.31341 0.955204 1.31341C0.318401 1.31341 0 1.0927 0 0.651275Z"
                        fill="currentColor"
                    />
                </svg>
            </div>
        </div>
		<div class="m-uspBlock">
			<div class="m-uspBlock__content">
				<h3 v-if="blockTitle" class="u-fs22">
					{{ blockTitle }}
				</h3>
				<p>
					{{ blockContent }}
				</p>
			</div>
        </div>
	</div>
</template>

<script setup>
import { ref } from 'vue';

defineProps( {
	label: {
		type: String,
		default: 'Info callout',
	},
	isActive: {
		type: Boolean,
		default: false,
	},
	placeholder: {
		type: String,
		default: 'Plaats hier aanvullende informatie over deze stap.',
	},
	blockTitle: {
		type: String,
		default: '',
	},
	blockContent: {
		type: String,
		default: '',
	},
} );

const emit = defineEmits( [ 'toggle' ] );

const isComponentActive = ref( false );

const handleToggle = () => {
	isComponentActive.value = ! isComponentActive.value;
	emit( 'toggle', isComponentActive.value );
};
</script>